import { useQuery } from "@tanstack/react-query";
import { SceneTemplate } from "@/model";
import templateRepository from "@/repository/templateRepository";


export const useTemplates = (scenarioId: string, condition?: string) => {
    return useQuery<SceneTemplate[]>({
        queryKey: ['templates', scenarioId, condition],
        queryFn: async () => {
            const data = await templateRepository.find(scenarioId, condition);
            return data.data ?? [];
        },
        enabled: !!scenarioId
    });
};
